import React, { useState, useEffect, cloneElement } from "react";
// import axios from "axios";
// import config from "../../config";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance
import { Link } from "react-router-dom";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    id:"",
    name: "",
    phoneNumber: "",
    password: "",
    role: "",
  });
  const axiosAPI = useAxios(); // Use the custom hook for Axios


  const resetForm = ()=>{
    setFormData({
      id:"",
      name: "",
      phoneNumber: "",
      password: "",
      role: "",
    })
  }

  // Function to handle input changes
  const handleChange = (e) => {
    // console.log("e",e.target.value)
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Function to fetch users data from the API
  const fetchUsers = async () => {
    try {
      const response = await axiosAPI.get(`/api/users/get-all-users`);
      const usersData = await response.data;

      setUsers(usersData);
      
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  // Fetch users when component mounts
  useEffect(() => {
    fetchUsers();
  }, []);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Check if email and password are not empty
  //   // if (!formData.phoneNumber || !formData.password) {
  //   //   window.notifyMessage(
  //   //     "Error",
  //   //     "Both phone number and password are mandatory.",
  //   //     "danger"
  //   //   );
  //   //   return; // Stop the form submission if either email or password is missing
  //   // } 
  //   // Regular expression for validating an email
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //   // Check if the email matches the regex
  //   // if (!emailRegex.test(formData.email)) {
  //   //   window.notifyMessage(
  //   //     "Error",
  //   //     "Please enter a valid email address.",
  //   //     "danger"
  //   //   );
  //   //   return; // Stop the form submission if the email is invalid
  //   // }
    
  //   const payload = {
  //     name:formData.name,
  //     phoneNumber:formData.phoneNumber,
  //     password:formData.password,
  //     role:formData.role
  //   }

  //   console.log("Payload is ",payload)

  //   // return

  //   try {
  //     // Make API call to add the user with email and password
  //     const response = await axiosAPI.post(`/api/users/add-user`, payload
  //   );

  //     // Notify user on successful user addition
  //     window.notifyMessage("Success", "Successfully added the user!");

  //     // Close the modal
  //     hideModal("newUserModal");

  //     // Reset the form fields
  //    resetForm()

  //     // Reload the users data
  //     fetchUsers();
  //   } catch (error) {
  //     // Check if it's an error from the API response
  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.message
  //     ) {
  //       window.notifyMessage(
  //         "Error",
  //         error.response.data.message, // Display the specific error message from the backend
  //         "danger"
  //       );
  //     } else {
  //       // Handle generic errors (e.g., network errors)
  //       window.notifyMessage("Error", "There was an error!", "danger");
  //     }
  //   }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Optional: Validate required fields
    if (!formData.name || !formData.phoneNumber || !formData.password) {
      window.notifyMessage(
        "Error",
        "Name, phone number, and password are required.",
        "danger"
      );
      return;
    }
  
    // Optional: Validate email if being used
    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        window.notifyMessage("Error", "Please enter a valid email address.", "danger");
        return;
      }
    }
  
    const payload = {
      name: formData.name,
      phoneNumber: formData.phoneNumber,
      password: formData.password,
      role: formData.role, // optional if not using roles
      email: formData.email, // include only if relevant
    };
  
    try {
      const response = await axiosAPI.post(`/api/users/add-user`, payload);
  
      window.notifyMessage("Success", "User added successfully!");
      hideModal("newUserModal");
      resetForm();
      fetchUsers();
    } catch (error) {
      const message =
        error.response?.data?.message || "Something went wrong while adding the user.";
      window.notifyMessage("Error", message, "danger");
    }
  };


  const openEditModal = (userId) => {
    const userToEdit = users.find((user) => user.id === userId);

    // console.log(userToEdit)

    if (userToEdit) {
      setFormData({
        id:userToEdit.id,
        name: userToEdit.full_name, // Set the full_name
        phoneNumber: userToEdit.phone_number, // Set the phone_number
        role:userToEdit.role // Set the role
      });

      // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
      showModal("editUserModal");
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const userId = formData.id; // Assuming user ID is part of formData

    // Prepare the data to be sent to the backend, removing unnecessary fields
    const dataToUpdate = {
      name: formData.name, // Send updated email
      phoneNumber: formData.phoneNumber , // Send password only if it's provided
      role:formData.role
    };


    try {
      const response = await axiosAPI.put(
        `/api/users/update-user/${userId}`,
        dataToUpdate // Send only the updated fields (email & password)
      );

      // Notify user of success
      window.notifyMessage("Success", "User updated successfully");

      // Close the modal (if you're using Bootstrap modal)
      hideModal("editUserModal");

      // Reload the users data after successful update
      fetchUsers();
    } catch (error) {
      // Check if it's an error from the API response
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display the specific error message from the backend
          "danger"
        );
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage(
          "Error",
          "There was an error updating the user.",
          "danger"
        );
      }
    }
  };

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div className="d-flex"></div>
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              data-bs-toggle="modal"
              data-bs-target="#newUserModal"
            >
              Add New User
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  New User
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="row">
                  {/* Form Section (Left Side) */}
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                      {/* Name  */}
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter your name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                    {/* Phone Number  */}
                      <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="number"
                          maxLength={10}
                          className="form-control"
                          id="phoneNumber"
                          placeholder="Enter your phone number"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {/* Password  */}
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Enter your password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {/* Role Selection */}
                      <div className="mb-3">
                        <label htmlFor="role" className="form-label">
                          Role
                        </label>
                        <select
                          className="form-select"
                          id="role"
                          name="role"
                          value={formData.role}
                          onChange={handleChange}
                          required
                        >
                          <option>Select</option>
                       
                          <option value="agent">Agent</option>
                        </select>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary btn-round btn-sm"
                      >
                        Add User
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit User Modal */}
        <div
          className="modal fade"
          id="editUserModal"
          tabIndex="-1"
          aria-labelledby="editUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="editUserModalLabel">
                  Edit User
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="row">
                  {/* Form Section (Left Side) */}
                  <div className="col-md-12">
                    <form onSubmit={handleEditSubmit}>
               
                         {/* Name  */}
                         <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter your name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                    {/* Phone Number  */}
                      <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="number"
                          maxLength={10}
                          className="form-control"
                          id="phoneNumber"
                          placeholder="Enter your phone number"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {/* Role Selection */}
                      <div className="mb-3">
                        <label htmlFor="role" className="form-label">
                          Role
                        </label>
                        <select
                          className="form-select"
                          id="role"
                          name="role"
                          value={formData.role}
                          onChange={handleChange}
                          required
                        >
                          <option>Select</option>
  
                          <option value="agent">Agent</option>
                        </select>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary btn-round btn-sm"
                      >
                        Update User
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title">
                      All Users (<span>{users.length}</span>)
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover basic-datatables">
                    <thead>
                      <tr>
                        <th>User Name</th>
                        <th>Phone Number</th>
                        <th>role </th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : (
                        users.map((user) => {
                          // Convert the created_at date to the desired format: '22 Dec 2024'
                          const formattedDate = new Date(
                            user.created_at
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={user.id}>
                              <td>{user.full_name}</td>
                              <td>{user.phone_number}</td>
                              <td>{user.role}</td>
                              <td>{formattedDate}</td>
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(user.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <Link to="/user-setting" className="logo">
                                  <button className="btn btn-icon btn-round btn-dark btn-sm d-none">
                                    <i className="fas fa-cog"></i>
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
